import { useState, useCallback } from 'react';
import SEO from '../../components/SEO';
import AdUnit from '../../components/AdUnit';

function Base64Tool() {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);

  var encode = useCallback(function () {
    if (!input.trim()) { setError('Please enter some text first.'); setOutput(''); return; }
    try { setOutput(btoa(unescape(encodeURIComponent(input)))); setError(''); }
    catch (e) { setError('Could not encode: ' + e.message); setOutput(''); }
  }, [input]);

  var decode = useCallback(function () {
    if (!input.trim()) { setError('Please enter a Base64 string first.'); setOutput(''); return; }
    try { setOutput(decodeURIComponent(escape(atob(input.trim())))); setError(''); }
    catch (e) { setError('Invalid Base64 string. Please check your input.'); setOutput(''); }
  }, [input]);

  var copy = useCallback(function () {
    if (!output) return;
    navigator.clipboard.writeText(output).then(function () { setCopied(true); setTimeout(function () { setCopied(false); }, 2000); });
  }, [output]);

  return (
    <div className="page-prettifier">
      <SEO title="Base64 Encoder & Decoder" description="Free online Base64 encoder and decoder. Convert text to Base64 and back instantly in your browser." path="/base64" />
      <div className="container">
        <div className="tool-header">
          <h1>Base64 Encoder & Decoder</h1>
          <p>Convert text to Base64 encoding or decode Base64 back to readable text.</p>
        </div>
        <AdUnit />
        <div className="toolbar">
          <div className="toolbar-right" style={{ width: '100%', justifyContent: 'flex-start' }}>
            <button onClick={encode} className="btn btn-primary" type="button">Encode</button>
            <button onClick={decode} className="btn btn-accent" type="button">Decode</button>
            <button onClick={copy} className="btn btn-secondary" type="button" disabled={!output}>{copied ? '✓ Copied' : 'Copy Result'}</button>
            <button onClick={function () { setInput(''); setOutput(''); setError(''); }} className="btn btn-secondary" type="button">Clear</button>
          </div>
        </div>
        {error && <div className="error-banner" role="alert"><span className="error-icon" aria-hidden="true">{"⚠"}</span> {error}</div>}
        <div className="editor-grid">
          <div className="editor-pane">
            <div className="pane-header"><span>Input</span><span className="char-count">{input.length} chars</span></div>
            <textarea className="editor-textarea" value={input} onChange={function (e) { setInput(e.target.value); }} placeholder="Enter text to encode, or Base64 to decode..." spellCheck={false} aria-label="Input" />
          </div>
          <div className="editor-pane">
            <div className="pane-header"><span>Output</span></div>
            <textarea className="editor-textarea output-textarea" value={output} readOnly placeholder="Result will appear here..." spellCheck={false} aria-label="Output" />
          </div>
        </div>
        <section className="tool-guide">
          <h2>What is Base64?</h2>
          <p>Base64 is a way to represent binary data using only text characters. It is commonly used in emails, web APIs, and data URLs. When you see a long string of letters, numbers, plus signs, and slashes, it is probably Base64 encoded data.</p>
        </section>
      </div>
    </div>
  );
}

export default Base64Tool;
